
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["init","updateFiles","getErrors"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "ed037613e4682d1c3195.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			